import axios from 'axios';
import Vue from 'vue'

const isCallAnswered = (item) => String(item.state) === '6'

const isExternalClientPhone = (phone) => {
  const value = String(phone || '')
  if (/^\d{4}$/.test(value)) {
    return false
  }

  return value.replace(/\D/g, '').length >= 10
}

const isInternalSip = (value) => /^\d{4}$/.test(String(value || ''))

const isUnansweredOperatorRing = (item) => (
  isExternalClientPhone(item.call_from)
  && isInternalSip(item.call_to)
  && !isCallAnswered(item)
)

const isOperatorBusy = (mySip, incomingCalls = []) => {
  if (!mySip) {
    return true
  }

  return incomingCalls.some((item) => (
    isCallAnswered(item)
    && (+item.call_to === +mySip || +item.call_from === +mySip)
  ))
}

const buildIncomingCallFromItem = (item, sip) => ({
  call_id: item.call_id,
  unique_id: item.unique_id,
  bridge_unique_id: item.bridge_unique_id,
  state: item.state,
  sip,
  phone: item.call_from,
  fio: item.user_from.fio,
  client_id: item.user_from.client_id,
  iin: item.user_from.iin,
})

export default {
  namespaced: true,
  state: {
    incomingCalls: [],
    groupCalls: [],
    incomingCallsNotAnswered: {},
    confirmPhone: '',
    timer: 0,
    lastUnicId: '',
    lastCallTimer: 0,
    lastCall: false,
  },
  getters: {
    confirmPhone: (state) => state.confirmPhone,
    timer: (state) => state.timer,
    getLastCall: (state) => state.lastCall,
    getLastCallTimer: (state) => state.lastCallTimer,
    hasLastCall: (state) => state.lastCall && Object.keys(state.lastCall).length > 0,
    incomingCallsNotAnswered: (state) => state.incomingCallsNotAnswered,
    isLastCallCurrent: (state, getters) => getters.getCall && state.lastCall ? state.lastCall?.unique_id === getters.getCall?.unique_id : false,
    getCalls: (state) => {
      let out = []
      for (let i in state.incomingCalls) {
        let item = state.incomingCalls[i]
        if (item.phone.length >= 3 && item.phone.length < 5) {
          out.push(item)
        }
      }
      return out
    },
    //возвращаем активный звонок или звонящего в ожидании для SIP авторизованного пользователя
    getCall: (state) => {
      let outCall = false
      const store = Vue.prototype.$store
      const mySip = store.getters['auth/sip'] == null ? '' : store.getters['auth/sip']
      const workStarted = !!store.getters['auth/workStarted']
      const busy = isOperatorBusy(mySip, state.incomingCalls)

      for (let i in state.incomingCalls) {
        const item = state.incomingCalls[i]
        const isInternalCallFrom = item.call_from
          && item.call_from.toString().length === 4
          && /^\d{4}$/.test(item.call_from.toString())

        if (isInternalCallFrom) {
          continue;
        }

        if (+item.call_from === +mySip) {
          outCall = {
            call_id: item.call_id,
            unique_id: item.unique_id,
            bridge_unique_id: item.bridge_unique_id,
            state: item.state,
            sip: item.call_from,
            phone: item.call_to,
            fio: item.user_to.fio,
            client_id: item.user_to.client_id,
            iin: item.user_to.iin,
          }
          continue
        }

        if (!isExternalClientPhone(item.call_from)) {
          continue
        }

        if (!outCall && isCallAnswered(item) && +item.call_to === +mySip) {
          outCall = buildIncomingCallFromItem(item, item.call_to)
          continue
        }

        if (outCall) {
          continue
        }

        const hasAnsweredForPhone = state.incomingCalls.some((call) => (
          call.call_from === item.call_from
          && isCallAnswered(call)
          && isInternalSip(call.call_to)
        ))
        if (hasAnsweredForPhone) {
          continue
        }

        if (isUnansweredOperatorRing(item) && workStarted && !busy) {
          outCall = buildIncomingCallFromItem(item, item.call_to)
        }
      }

      if (outCall) {
        if (outCall.unique_id !== state.lastUnicId) {
          state.lastUnicId = outCall.unique_id;
          state.timer = 0;
        }
      } else {
        state.timer = 0;
      }

      return outCall
    },
  },
  actions: {
    updateIncomingCalls({state}, callsArr) {
      state.incomingCalls = callsArr?.calls || []
    },
    updateIncomingCallsNotAnswered({state}, callsArr) {
      state.incomingCallsNotAnswered = callsArr['calls'];
    },
    setPhoneConfirmCall({state}, phone) {
      state.confirmPhone = phone
    },
    startCall({state, rootState}) {
      axios.post('operator/start-call', {phone: state.confirmPhone, sip: rootState.auth.user.sip}).then((e) => {
        if (e.data.success) {
          console.log('Запрос на дозвон успешно отправлен')
        } else {
          console.log('Запрос на дозвон завершился ошибкой')
        }
      })
    },
    setLastCall({state}, call) {
      state.lastCall = call
      state.lastCallTimer = state.timer
    },
    updateLastCall({state}, call) {
      state.lastCall = {...call}
    },
    updateTimer({state, getters}) {
      state.timer++;
      if (getters.hasLastCall && getters.isLastCallCurrent) {
        state.lastCallTimer++;
      }
    },
    async saveCall({state}, call) {
      try {
        await axios.post('/asterisk/save/call/data', {
          unique_id: call.unique_id,
          topic: call.call_topic || '',
          subTopic: call.call_sub_topic || '',
          comment: call.call_comment || '',
          bin: call.bin || '',
          call_id: call.call_id,
          call_source: call.call_source || '',
          fio: call.fio || '',
          phone: call.phone || '',
          iin: call.iin || '',
          product: call.product || '',
          is_fio_mismatch: call.isFioMismatch ? 1 : 0
        })
        console.log('Звонок сохранен')
        state.lastCall = false
      } catch (e) {
        console.log('Звонок не сохранен')
        console.log(e)
        try {
          await axios.post('/debug/log', {
            call,
            error: e,
            response: e?.response || null,
            unique_id: call?.unique_id,
            bridge_unique_id: call?.bridge_unique_id,
            call_id: call.call_id
          })
        } catch (e) {
          console.log('Ошибка логирования')
        }
      }
    },
  },
}
